import React from "react";

import Widget from "2g-widget";

import ZadostiGroups from "b2b/components/zadosti-groups";
import ZadostiOdsouhlaseneTable from "b2b/components/zadosti-odsouhlasene-table/ZadostiOdsouhlaseneTable";
import { STAV } from "b2b/constants/zadosti";

import useMessages from "./i18n/useMessages";
import useZadostiOdsouhlaseneWidget from "./useZadostiOdsouhlaseneWidget";

export function ZadostiOdsouhlaseneWidget() {
  const { messageEmpty, widgetLabel } = useMessages();
  const { obdobi, onChange, zdroj } = useZadostiOdsouhlaseneWidget();
  return (
    <Widget collapsable={false} title={widgetLabel()}>
      <ZadostiGroups
        datumDo={obdobi.datumDo}
        datumOd={obdobi.datumOd}
        messageEmpty={messageEmpty()}
        onChange={onChange}
        value={zdroj}
        showAll={true}
        stav={STAV.POTVRZENY}
      />
      <ZadostiOdsouhlaseneTable
        datumDo={obdobi.datumDo}
        datumOd={obdobi.datumOd}
        zdroj={zdroj}
        hideIfEmpty
      />
    </Widget>
  );
}

export default React.memo(ZadostiOdsouhlaseneWidget);
